import * as v from "valibot";
import { baseVals, defineValidation } from "../../common/validation.common";

export namespace DebugToolsValidation {
    export const Notify = defineValidation(
        v.object({
            deviceToken: baseVals.string(),
            title: baseVals.string(),
            message: baseVals.string(),
            imageURL: v.optional(baseVals.string()),
        }),
    );

    export const SendWhatsAppInvoice = defineValidation(
        v.object({
            dstPhone: baseVals.phone(),
            associateId: baseVals.string(),
        }),
    );

    export const StandaloneDaemon = defineValidation(
        v.object({
            key: baseVals.string(),
            date: baseVals.isoDate(),
        }),
    );

    export const AssociateDaemon = defineValidation(
        v.object({
            key: baseVals.string(),
            date: baseVals.isoDate(),
            associateId: baseVals.string(),
        }),
    );
}
